import { MutationTree } from 'vuex';
import { RallyIntelligenceState } from '../types';
import Vue from 'vue';

export const mutations: MutationTree<RallyIntelligenceState> = {
	SET_PROMPTS(state: RallyIntelligenceState, prompts: RallyIntelligencePromptResponse[]): void {
		Vue.set(state, 'prompts', prompts);
	},

	ADD_PROMPT(state: RallyIntelligenceState, prompt: RallyIntelligencePromptResponse): void {
		Vue.set(state, 'prompts', [...state.prompts, prompt]);
	},

	UPDATE_PROMPT(state: RallyIntelligenceState, prompt: RallyIntelligencePromptResponse): void {
		const prompts = state.prompts.map(p => (p.id === prompt.id ? prompt : p));
		Vue.set(state, 'prompts', prompts);
	},

	REMOVE_PROMPT(state: RallyIntelligenceState, promptId: number): void {
		Vue.set(state, 'prompts', state.prompts.filter(p => p.id !== promptId));
	},

	SET_ACTIVE_PROMPT(state: RallyIntelligenceState, promptId: number): void {
		const prompts = state.prompts.map(p => ({ ...p, is_active: p.id === promptId }));
		Vue.set(state, 'prompts', prompts);
	},

	SET_CONFIGURATION(state: RallyIntelligenceState, configuration: RallyIntelligenceConfigurationResponse): void {
		Vue.set(state, 'configuration', configuration);
	},

	SET_USAGE(state: RallyIntelligenceState, usage: RallyIntelligenceUsageResponse): void {
		Vue.set(state, 'usage', usage);
	},

	SET_FETCH_PROMPTS_COMPLETE(state: RallyIntelligenceState, complete: boolean): void {
		Vue.set(state, 'fetchPromptsComplete', complete);
	}
};
